import * as React from "react";
const SvgTimeGreen = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 13" {...props}><path stroke="#079455" strokeLinecap="round" strokeLinejoin="round" d="M6 3.5v3l2 1m3-1a5 5 0 1 1-10 0 5 5 0 0 1 10 0" /></svg>;
export default SvgTimeGreen;